import { useState } from "react";
import { StringNumber, TCelulaCadastro, TSede } from "../../../../../types";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import api from "../../../../../utils/api";


export type ResponseServiceEdit = {
  celulaSelecionada: TSede|undefined;
  cadastrarCelula: VoidFunction;
  changeCampusCelula: (campo: keyof TSede, valor: StringNumber | null) => void;
};

export const ServicesCadastrar = (): ResponseServiceEdit => {
  const [celulaSelecionada, setCelulaSelecionada] = useState<TSede>();

  const { setErrorSuccess } = useErrorSuccess();

  const cadastrarCelula = async () => {
    try {
      const req = await api.post('sede/geral', celulaSelecionada);
      const res = req?.data;

      setErrorSuccess({ mensagem: 'Celula Atualizada', status: 'success' })
    } catch(error) {
      setErrorSuccess({ mensagem: 'error', status: 'error' })
    }
  };

  const changeCampusCelula = (campo: keyof TSede, value: StringNumber | null) => {
    setCelulaSelecionada(
      (valor: any) => {
      return { ...valor, [campo]: value }
    }
  )
  }

  return {
    celulaSelecionada,
    cadastrarCelula,
    changeCampusCelula
  }
};
